import area from "@turf/area";
import bbox from '@turf/bbox';
import buffer from "@turf/buffer";
import { Feature, MultiPolygon, Polygon } from "geojson";

export function geoJsonGetAreaInHa( feature: Polygon | MultiPolygon) {
    return Math.round(area(feature) / 10000 * 100) / 100;
}

export function geoJsonGetBbox ( feature: Feature) {
    return bbox(feature);
}

export function getBufferPolygon(feature: Feature, radius: number, steps?: number) {
    return buffer(feature, radius, { units: 'kilometers', steps: steps ? steps : 3});
}

export const pointInsidePolygon = (point: number[], poly: number[][][]) => {
   let inside = false;
   let x = point[0], y = point[1];
   for (let ii = 0; ii < poly.length; ii++) {
      let polyPoints = poly[ii];
      for (let i = 0, j = polyPoints.length - 1; i < polyPoints.length; j = i++) {
         let xi = polyPoints[i][0], yi = polyPoints[i][1];
         let xj = polyPoints[j][0], yj = polyPoints[j][1];

         let intersect = ((yi > y) !== (yj > y))
            && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
         if (intersect) inside = !inside;
      }
   }
   return inside;
};